import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { DATE_FORMATS_MAP, DateFormats, DEFAULT_LANG, TRANSLATION_LOCALES_MAP } from '@cpak/consts';
import { UserPreferencesFacade } from '../../../data-store/global-config-store/state/user-preferences/user-preferences.facade';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest } from 'rxjs';

@UntilDestroy()
@Pipe({
  name: 'cpakDate',
})
export class CpakDatePipe implements PipeTransform {
  private timeZone = '';
  private localeId = DEFAULT_LANG;
  constructor(private datePipe: DatePipe, private userPreferencesFacade: UserPreferencesFacade) {
    combineLatest([this.userPreferencesFacade.getTimeZone(), this.userPreferencesFacade.getLanguage()])
      .pipe(untilDestroyed(this))
      .subscribe(([timeZone, language]) => {
        this.timeZone = timeZone;
        this.localeId = TRANSLATION_LOCALES_MAP.get(language) || DEFAULT_LANG;
      });
  }
  transform(
    value: Date | string | number | null | undefined,
    format: DateFormats = DateFormats.DateFormatWithTime,
    timeZone?: string
  ): string | null {
    if (!timeZone && this.timeZone) {
      timeZone = this.timeZone;
    }
    const dateFormat = {
      ...DATE_FORMATS_MAP.get(format),
      timeZone,
    };
    if (!value) return null;
    return new Date(value).toLocaleDateString(this.localeId, dateFormat);
  }
}
